export default __webpack_public_path__ + "static/media/logo.23222c36.png";